export default __webpack_public_path__ + "static/media/equity-banner.4c258d0e.jpg";